// Testimonials.jsx
import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { FaArrowLeft, FaArrowRight } from 'react-icons/fa';


const Testimonials = () => {
  const testimonials = [
    {
      quote: "Bhagya has a rare ability to see both the detail and the bigger picture, making him perfectly equipped to be a team leader for creating the future.",
      detail: "I have worked with Bhagya to advance the understanding of human performance enhancement through AI-enabled layers, including explicit and tacit interpretation of communication and achievement. He quickly perceives global challenges and systematically identifies avenues to advance the bigger picture.",
      author: 'Dr. Kwong Chan',
      position: 'Senior Academic Specialist, Marketing; Executive Director, DMSB AI Strategic Hub',
      company: 'Northeastern University',
    },
    {
      quote: "Bhagya's quick learning and problem-solving skills make him an exceptional team player and professional.",
      detail: "I’ve worked with Bhagya for 1.5 years, where I served as the Team Lead for a US-based project. Bhagya's standout qualities include his quick learning ability and exceptional problem-solving skills, particularly in the context of Angular-based UI applications. His commitment to his work and self-sufficiency in finding solutions to challenges were truly impressive. Bhagya is a true professional and team player and I would highly recommend him for any role.",
      author: 'Rahul Maurya',
      position: 'Senior Consultant',
      company: 'Deloitte',
    },
    {
      quote: "Bhagya's eagerness to learn and execute with precision makes him a standout professional, even during his internship.",
      detail: "One of the go-to people I came across who has the urge of learning new things and executes perfectly as an intern. I wish him all the best for his future endeavors.",
      author: 'Sharath Adsumillie',
      position: 'Vice President',
      company: 'HDFC Ergo',
    },
    {
      quote: "Bhagya possesses a rare combination of technical acumen and creativity, consistently delivering innovative solutions and maintaining exceptional standards in Java Full Stack Development.",
      detail: "During his time at Deloitte, Bhagya showcased expertise in frameworks like Spring and Angular, driving successful project deliveries. His attention to detail, proactive communication, and ability to collaborate effectively made him an asset to the team. He consistently demonstrated a strong work ethic, taking ownership of tasks and ensuring timely, high-quality results, positively influencing team performance and client satisfaction.",
      author: 'Anuj Pandit',
      position: 'Senior Manager',
      company: 'Deloitte USI',
    },
    {
      quote: "An incredibly talented developer who consistently delivers high-quality work.",
      detail: "Bhagya spearheaded the Software Development and Cloud Native Development for the PresBot project at LearnBot",
      author: 'Dr. Debashish Ghose',
      position: 'Visiting Assistant Professor, Marketing',
      company: 'Northeastern University',
    },
  ];

  const [currentIndex, setCurrentIndex] = useState(0);

  const handleNext = () => {
    setCurrentIndex((prevIndex) => (prevIndex + 1) % testimonials.length);
  };

  const handlePrev = () => {
    setCurrentIndex(
      (prevIndex) => (prevIndex - 1 + testimonials.length) % testimonials.length
    );
  };

  return (
    <motion.div
      className="testimonials-section"
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ duration: 1.5 }}
    >
      <motion.h2
        className="testimonials-title"
        initial={{ y: -50, opacity: 0 }}
        animate={{ y: 0, opacity: 1 }}
        transition={{ duration: 0.8 }}
      >
        Testimonials
      </motion.h2>
      <div className="testimonials-container" aria-live="polite">
        {/* Left Arrow */}
        <motion.div
          className="arrow left-arrow"
          onClick={handlePrev}
          whileHover={{ scale: 1.2 }}
          whileTap={{ scale: 0.9 }}
          aria-label="Previous Testimonial"
          role="button"
          tabIndex={0}
          onKeyPress={(e) => {
            if (e.key === 'Enter') handlePrev();
          }}
        >
          <FaArrowLeft />
        </motion.div>

        {/* Testimonial Card */}
        <AnimatePresence mode="wait">
          <motion.article
            key={currentIndex}
            className="testimonial-card"
            initial={{ opacity: 0, x: -100 }}
            animate={{ opacity: 1, x: 0 }}
            exit={{ opacity: 0, x: 100 }}
            transition={{ duration: 0.6 }}
          >
            <motion.blockquote
              className="testimonial-quote"
              whileHover={{ color: '#4e54c8' }}
            >
              "{testimonials[currentIndex].quote}"
            </motion.blockquote>
            <p className="testimonial-detail">
              {testimonials[currentIndex].detail}
            </p>
            <footer className="testimonial-author">
              <motion.p
                className="author-name"
                whileHover={{ scale: 1.1 }}
              >
                {testimonials[currentIndex].author}
              </motion.p>
              <cite className="author-position">
                {testimonials[currentIndex].position}, {testimonials[currentIndex].company}
              </cite>
            </footer>
          </motion.article>
        </AnimatePresence>

        {/* Right Arrow */}
        <motion.div
          className="arrow right-arrow"
          onClick={handleNext}
          whileHover={{ scale: 1.2 }}
          whileTap={{ scale: 0.9 }}
          aria-label="Next Testimonial"
          role="button"
          tabIndex={0}
          onKeyPress={(e) => {
            if (e.key === 'Enter') handleNext();
          }}
        >
          <FaArrowRight />
        </motion.div>
      </div>
    </motion.div>
  );
};

export default Testimonials;
